module.exports = __webpack_public_path__ + "img/icon_no_data.3e7b2fc8.svg";